import { createFileRoute, redirect } from '@tanstack/react-router'
import { Login } from '../../pages/Login'
import { getAccessToken } from '@/utils/storage/authStorage'

export const Route = createFileRoute('/(auth)/_auth/login')({
  component: Login,
  validateSearch: (search: Record<string, unknown>): { returnTo?: string } => {
    return {
      returnTo: search['returnTo'] as string,
    };
  },
  beforeLoad: async() => {
    const accessToken = await getAccessToken()
    if (accessToken) {
      redirect({
        to: '/',
        throw: true
      })
    }
  },
})